var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"legend-panel card"},[_c('div',{staticClass:"header dark f-row-ac"},[_c('translate',{staticClass:"mx-2"},[_vm._v("Legend")])],1),_c('map-legend',{attrs:{"visible":_vm.visible}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }